import React, { useContext } from "react";
import LocationDetailsDesktop from "./Platforms/Desktop/LocationDetailsDesktop";
import LocationDetailsMobile from "./Platforms/Mobile/LocationDetailsMobile";
import { DayUseContext } from "../../../../context/DayUseContext";

const LocationDetailsView = ({ isDesktop }) => {
  const {
    setView,
    updateHotelSelection,
    dayUseHotelDetailsLocation,
    setDayUseHotelDetailsLocation,
  } = useContext(DayUseContext);

  return (
    <>
      {isDesktop ? (
        <LocationDetailsDesktop
          hotelDetailsLocation={dayUseHotelDetailsLocation}
          setHotelDetailsLocation={setDayUseHotelDetailsLocation}
          updateHotelSelection={updateHotelSelection}
          setView={setView}
        />
      ) : (
        <LocationDetailsMobile
          hotelDetailsLocation={dayUseHotelDetailsLocation}
          setHotelDetailsLocation={setDayUseHotelDetailsLocation}
          updateHotelSelection={updateHotelSelection}
          setView={setView}
        />
      )}
    </>
  );
};

export default LocationDetailsView;
